import { Component, OnInit } from '@angular/core';
import { AppConfigService } from '../services/config/app-config.service';
import { Router, RouterModule } from '@angular/router';
import { CommonUtilService } from '../services/common-util/common-util.service';
import { DpTabMenuV3Component } from "../common-component/dp-tab-menu-v3/dp-tab-menu-v3.component";
@Component({
  selector: 'app-work-history-main',
  standalone: true,
  templateUrl: './work-history-main.component.html',
  styleUrl: './work-history-main.component.scss',
  imports: [RouterModule, DpTabMenuV3Component],
})
export class WorkHistoryMainComponent implements OnInit {
  constructor(
  ) { }
  public isMobileDevice: boolean = false;
  routArray: any = [];
  ctx: any = [];
  role: any;
  ngOnInit(): void {
    this.role = localStorage.getItem('role');
  }
}
